"use client";
import React, { createContext, useContext, useState, ReactNode } from "react";

// Tipos das variáveis de login
export interface AuthContextType {
  loginUnidade: string;
  setLoginUnidade: (value: string) => void;
  loginUsuario: string;
  setLoginUsuario: (value: string) => void;
  loginSenha: string;
  setLoginSenha: (value: string) => void;
  loginGrupoId: string;
  setLoginGrupoId: (value: string) => void;
  loginGrupoNome: string;
  setLoginGrupoNome: (value: string) => void;
  loginLoginId: string;
  setLoginLoginId: (value: string) => void;
  loginLoginNome: string;
  setLoginLoginNome: (value: string) => void;
  loginDepartamentoId: string;
  setLoginDepartamentoId: (value: string) => void;
  permissoes: Record<string, Record<string, string>> | null;
  setPermissoes: (value: Record<string, Record<string, string>> | null) => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export function AuthProvider({ children }: { children: ReactNode }) {
  const [loginUnidade, setLoginUnidade] = useState("");
  const [loginUsuario, setLoginUsuario] = useState("");
  const [loginSenha, setLoginSenha] = useState("");
  const [loginGrupoId, setLoginGrupoId] = useState("");
  const [loginGrupoNome, setLoginGrupoNome] = useState("");
  const [loginLoginId, setLoginLoginId] = useState("");
  const [loginLoginNome, setLoginLoginNome] = useState("");
  const [loginDepartamentoId, setLoginDepartamentoId] = useState("");
  const [permissoes, setPermissoes] = useState<Record<string, Record<string, string>> | null>(null);

  return (
    <AuthContext.Provider
      value={{
        loginUnidade,
        setLoginUnidade,
        loginUsuario,
        setLoginUsuario,
        loginSenha,
        setLoginSenha,
        loginGrupoId,
        setLoginGrupoId,
        loginGrupoNome,
        setLoginGrupoNome,
        loginLoginId,
        setLoginLoginId,
        loginLoginNome,
        setLoginLoginNome,
        loginDepartamentoId,
        setLoginDepartamentoId,
        permissoes,
        setPermissoes,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuth deve ser usado dentro de um AuthProvider");
  }
  return context;
} 